<!-- 菜单项，不包含子菜单 -->
<template>
  <el-menu-item
    v-if="hasRight"
    :index="index"
    class="st-menu-item"
    :class="{ 'has-icon': !noButton }"
  >
    <CmdTooltip
      :table="tableName"
      :index="index"
      :tip="tooltip"
      :detail="detail"
    >
      <ElIcon v-if="icon"><component :is="icon" /></ElIcon>
      {{ label }}
    </CmdTooltip>

    <ElIcon v-if="!noButton && current == index" class="st-menu-icon" current>
      <Icons.easyCmdPushpinactive @click="setDefaultMenu" />
    </ElIcon>
    <ElIcon v-else-if="!noButton" class="st-menu-icon">
      <el-tooltip content="设置为默认操作" :show-after="1000">
        <Icons.easyCmdThumbtack @click="setDefaultMenu" />
      </el-tooltip>
    </ElIcon>
  </el-menu-item>
</template>

<script setup lang="ts">
/**
 * ### 菜单项，作为cmd-menu的子组件存在
 * <warning> 该组件作为 cmd-menu 组件的最终叶子节点存在 不可有下一级菜单项
 */
import type { Component } from 'vue';
import { inject } from 'vue';
import { ElMenuItem, ElIcon, ElTooltip } from 'element-plus';
import { Icons } from '../../common/Icons';
import { useShareData } from '../../core/SharedData';
import { canAccess } from '../../core/CmdRightsControl';
import CmdTooltip from './CmdTooltip.vue';

const props = defineProps<{
  /**
   * ### 操作按钮唯一key
   * 用以与句柄函数对象key关联
   */
  index: string;
  /**
   * ### 操作按钮名称
   */
  label: string;
  /**
   * ### 当按钮置顶后在主按钮显示的文案
   */
  text?: string;
  /**
   * ### 按钮图标
   */
  icon?: Component;
  /**
   * ### 权限code
   */
  require?: string;
  /**
   * ### 帮助描述文字, “列表配置”中显示
   */
  info?: string;
  /**
   * ### tooltip帮助, 不填使用info
   */
  help?: string;
  /**
   * ### tooltip帮助, 不填使用info
   * <warning> 优先级低于help
   */
  tip?: string;
  /**
   * ### 在tooltip中显示“详见”按钮 点击后弹窗该文案
   * <warning> 需配合 help/tip/info之一一起使用
   */
  detail?: boolean;
}>();

// tooltip
const tooltip = props.help || props.tip || props.info;
const tableName = useShareData('table', 'name');

const report = useShareData('cmdbar:menu', 'report');
const setCurrent = useShareData('cmdbar:menu', 'set');
const current = useShareData('cmdbar:menu', 'current');

const hasRight = canAccess(props.require);

const noButton = inject('st-menu-no-button', false);
//const parentButton = inject('cmdbar:button', undefined) as any;
// 向上级报告自己的存在
const help = { tip: tooltip, detail: props.detail };
if (hasRight && !noButton)
  report?.(props.index, props.text || props.label, help);

function setDefaultMenu(e: MouseEvent) {
  e.preventDefault();
  e.stopPropagation();

  setCurrent?.(props.index, props.text || props.label, help);
}
</script>

<style lang="scss" scoped>
.st-menu-icon {
  position: absolute;
  right: 4px;
  visibility: hidden;
  width: 14px;
  height: 14px;
}

.st-menu-icon[current] {
  visibility: visible;
}

.st-menu-item:hover > .st-menu-icon {
  visibility: visible;
  color: #898b8f;
}

.st-menu-item.has-icon {
  padding-right: 40px !important;
}
</style>
